import { splitTextAndLatex } from 'general_function'
import React from 'react'
import { InlineMath } from 'react-katex'

export default function TextWithLatex({ text }) {
    return splitTextAndLatex(text).map(
        (m, index) => (
            <React.Fragment key={index}>
                {m.type === "text" ? (
                    <span text-type="text" style={{ whiteSpace: "pre-line" }}>
                        {m.content}
                    </span>
                ) : (
                    <span
                        text-type="latex"
                        contentEditable={false}
                        latex-content={`$${m.content}$`}
                    >
                        <InlineMath
                            math={m.content}
                        />
                    </span>
                )}
            </React.Fragment>
        )
    )
}
